const HTML_ENTITIES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;",
};
export function escapeHtml(value) {
    return value.replace(/[&<>"']/g, (character) => HTML_ENTITIES[character]);
}
